const BaseError = require('make-error').BaseError;

class MissingAuthorizationError extends BaseError {
    constructor(errorMessage='Missing or malformed authorization information.') {
        super(errorMessage);
        this._isUserError = true;
    }
}

module.exports = MissingAuthorizationError;